<template>
  <div class="iframe-wrapper">
    <vue-friendly-iframe ref="iframeEl" v-loading="iframeLoading" :style="{ 'display' : iframeLoading ? 'none' : 'block' }" :src="url" frameborder="0" gesture="media" allow="encrypted-media" @load="onLoad" />
  </div>
</template>
<script>
import vueFriendlyIframe from './components/friendly-iframe'
export default {
  components: {
    vueFriendlyIframe
  },
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      iframeLoading: true
    }
  },
  methods: {
    onLoad() {
      console.log('iframe loaded')
      this.iframeLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe-wrapper{
  /deep/ {
    iframe {
      height: 100vh;
      width: 100%;
      position: absolute;
    }
  }
}
</style>
